{
  "Repo": "https://lba-consulting@dev.azure.com/lba-consulting/Abercrombie%20and%20Kent/_git/AK%20Frontend%20Reservation",
  "LastCommitHash": "cd2381965ec07e4db4d348c729c6bde830180557",
  "LastCommitMessage": "Merge branch uat_price-setup-changes into dev-update-version19",
  "LastCommitAuthor": "roberto.dipiano",
  "LastCommitTime": "Thu Nov 5 12:48:20 2026 +0100",
  "VersionNumber": "22049"
}